import { render, staticRenderFns } from "./CategoriaPreview.vue?vue&type=template&id=734d07a3"
import script from "./CategoriaPreview.vue?vue&type=script&lang=js"
export * from "./CategoriaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports